var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basic Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4109 11.9999L17.7109 7.70994C17.8992 7.52164 18.005 7.26624 18.005 6.99994C18.005 6.73364 17.8992 6.47825 17.7109 6.28994C17.5226 6.10164 17.2672 5.99585 17.0009 5.99585C16.7346 5.99585 16.4792 6.10164 16.2909 6.28994L12.0009 10.5899L7.71092 6.28994C7.52261 6.10164 7.26722 5.99585 7.00092 5.99585C6.73461 5.99585 6.47922 6.10164 6.29092 6.28994C6.10261 6.47825 5.99682 6.73364 5.99682 6.99994C5.99682 7.26624 6.10261 7.52164 6.29092 7.70994L10.5909 11.9999L6.29092 16.2899C6.19719 16.3829 6.12279 16.4935 6.07202 16.6154C6.02126 16.7372 5.99512 16.8679 5.99512 16.9999C5.99512 17.132 6.02126 17.2627 6.07202 17.3845C6.12279 17.5064 6.19719 17.617 6.29092 17.7099C6.38388 17.8037 6.49448 17.8781 6.61634 17.9288C6.7382 17.9796 6.8689 18.0057 7.00092 18.0057C7.13293 18.0057 7.26363 17.9796 7.38549 17.9288C7.50735 17.8781 7.61795 17.8037 7.71092 17.7099L12.0009 13.4099L16.2909 17.7099C16.3839 17.8037 16.4945 17.8781 16.6163 17.9288C16.7382 17.9796 16.8689 18.0057 17.0009 18.0057C17.1329 18.0057 17.2636 17.9796 17.3855 17.9288C17.5074 17.8781 17.618 17.8037 17.7109 17.7099C17.8046 17.617 17.879 17.5064 17.9298 17.3845C17.9806 17.2627 18.0067 17.132 18.0067 16.9999C18.0067 16.8679 17.9806 16.7372 17.9298 16.6154C17.879 16.4935 17.8046 16.3829 17.7109 16.2899L13.4109 11.9999Z",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.bbae243d06ff200000ddf9ea30bb58fd.svg";
export { ForwardRef as ReactComponent };